import React from 'react';
import MeusPedidos from '@/components/pedidos/MeusPedidos';

// 10/10/2026: as marcações (fluxo antigo) deram lugar aos pedidos.
const Appointments: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <MeusPedidos />
        </div>
      </div>
    </div>
  );
};

export default Appointments;
